<nz-modal
  nzWrapClassName=""
  [(nzVisible)]="isVisibleModal"
  [nzClosable]="!isVisibleModal"
  [nzTitle]="modalTitle"
  [nzCentered]="true"
  [nzClassName]="'modal-m-t-30'"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  [nzMaskStyle]="{'background': 'rgba(255, 255, 255, 0.69)'}">
  <ng-template #modalTitle>
  </ng-template>

  <ng-template #modalContent>
    <div class="d-flex justify-content-center align-items-center flex-column">
      <img loading="lazy" src="./../../../assets/images/wait.jpg" alt="" style="height: 220px;">
      <p class="text-info mt-xlg">
        <i nz-icon nzType="loading" nzTheme="outline" class="mr-xxs"></i>
        Estamos verificando el proceso de suscripción
      </p>
      <p class="text-info mt-xlg" *ngIf="(this.subscriptionStripe$ | async) as subscriptionStripe">
        ¿No se abrió una ventana o pestaña emergente?, da clic <a [href]="subscriptionStripe.url" target="_blank"> aquí </a>
      </p>
    </div>
  </ng-template>

  <ng-template #modalFooter>
    <div class="container-footer-modal d-flex justify-content-center" [@fadeInAnimation]>
      <button
        (click)="onEmitSubscribe()"
        nz-button nzType="primary">
        <i nz-icon nzType="retweet" nzTheme="outline"></i>
        INTENTARLO DE NUEVO</button>
    </div>
  </ng-template>
</nz-modal>
